import { Severity, useSnackbarStore } from '../store/snackbarStore'
import { sounds } from './sound'

// Every snackbar routes through here, so this is the single place that pairs a
// tone with a message: warnings and errors each get their own distinct sound.
const severitySound: Partial<Record<Severity, () => void>> = {
    warning: sounds.warning,
    error: sounds.error,
}

export const showMessage = (message: string, severity: Severity = 'success', duration: number | null = 5000) => {
    severitySound[severity]?.()
    useSnackbarStore.getState().showMessage(message, severity, duration)
}
